import {
  Navigate,
  Routes as ReactRoutes,
  Route,
  useLocation,
} from 'react-router-dom';

import LineEditor from 'scenes/LineEditor';
import LinesOverview from 'scenes/Lines';
import Providers from 'scenes/Providers';
import ProviderEditor from 'scenes/Providers/Editor';
import LineMigration from 'scenes/Providers/LineMigration';
import ExportsOverview from '../Exports';
import ExportsEditor from '../Exports/Creator';
import ExportsViewer from '../Exports/Viewer';
import FlexibleLineEditor from '../FlexibleLineEditor';
import FlexibleLinesOverview from '../FlexibleLines';
import NetworksOverview from '../Networks';
import NetworkEditor from '../Networks/Editor';
import StopPlacesOverview from '../StopPlaces';
import StopPlacesEditor from '../StopPlaces/scenes/Editor';
import { useNoProviders } from './useNoProviders';
import { useNoSelectedProvider } from './useNoSelectedProvider';
import { NoSelectedProvider } from './NoSelectedProvider/NoSelectedProvider';
import { useAppSelector } from '../../store/hooks';
import Brandings from '../Brandings';
import BrandingEditor from '../Brandings/Editor';
import DayTypesOverview from '../DayTypes';
import DayTypeEditor from '../DayTypes/Editor';
import { useConfig } from 'config/ConfigContext';

export const SELECT_PROVIDER_PATH = '/select-provider';

const Routes = () => {
  const noProviders = useNoProviders();
  const noSelectedProvider = useNoSelectedProvider();
  const location = useLocation();
  const isAdmin = useAppSelector((state) => state.userContext.isAdmin);
  const config = useConfig();
  const isLineMigrationEnabled = config?.enableLineMigration ?? false;

  if (noProviders && !location.pathname.startsWith('/providers') && isAdmin) {
    return <Navigate to="/providers" replace />;
  }

  if (
    noSelectedProvider &&
    location.pathname !== SELECT_PROVIDER_PATH &&
    !location.pathname.startsWith('/providers')
  ) {
    return <Navigate to={SELECT_PROVIDER_PATH} replace />;
  }

  return (
    <div>
      <ReactRoutes>
        <Route path="/" element={<Navigate to="/lines" replace />} />
        <Route path="/brandings" element={<Brandings />} />
        <Route path="/brandings/create" element={<BrandingEditor />} />
        <Route path="/brandings/edit/:id" element={<BrandingEditor />} />
        <Route path="/day-types" element={<DayTypesOverview />} />
        <Route path="/day-types/create" element={<DayTypeEditor />} />
        <Route path="/day-types/edit/:id" element={<DayTypeEditor />} />
        <Route path="/networks" element={<NetworksOverview />} />
        <Route path="/networks/create" element={<NetworkEditor />} />
        <Route path="/networks/edit/:id" element={<NetworkEditor />} />
        <Route path="/lines" element={<LinesOverview />} />
        <Route path="/lines/edit/:id" element={<LineEditor />} />
        <Route path="/lines/create" element={<LineEditor />} />
        <Route path="/flexible-lines" element={<FlexibleLinesOverview />} />
        <Route path="/flexible-lines/create" element={<FlexibleLineEditor />} />
        <Route
          path="/flexible-lines/edit/:id"
          element={<FlexibleLineEditor />}
        />
        <Route path="/stop-places" element={<StopPlacesOverview />} />
        <Route path="/stop-places/create" element={<StopPlacesEditor />} />
        <Route path="/stop-places/edit/:id" element={<StopPlacesEditor />} />
        <Route path="/exports" element={<ExportsOverview />} />
        <Route path="/exports/create" element={<ExportsEditor />} />
        <Route path="/exports/view/:id" element={<ExportsViewer />} />
        <Route path="/providers" element={<Providers />} />
        <Route path="/providers/create" element={<ProviderEditor />} />
        <Route path="/providers/edit/:id" element={<ProviderEditor />} />
        {isLineMigrationEnabled && (
          <Route
            path="/providers/:providerId/migrate-line"
            element={<LineMigration />}
          />
        )}
        <Route path={SELECT_PROVIDER_PATH} element={<NoSelectedProvider />} />
      </ReactRoutes>
    </div>
  );
};

export default Routes;
